import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { SideBar } from '../common/sideBar'
import {
  selectComponentAuthorized,
  selectUserType,
} from '../layout/store/slice'
import { getIsLock } from './helper'
import './lang/i18n'

export const getListSideBar = (userType, AUTHORIZATION_API) => [
  {
    route: '/library/savedPortfolios',
    label: 'library.main.SAVED_PORTFOLIO',
    isLock: getIsLock(
      userType,
      AUTHORIZATION_API.library.savedPortfolios.savedPortfolio,
    ),
  },
  {
    route: '/library/filteredCompanies',
    label: 'library.main.FILTERED_COMPANIES',
    isLock: getIsLock(
      userType,
      AUTHORIZATION_API.library.filteredCompanies.filteredCompany,
    ),
  },
  {
    route: '/library/followingList',
    label: 'library.main.FOLLOWING_LIST',
    isLock: getIsLock(userType, AUTHORIZATION_API.library.followingList),
  },
  {
    route: '/library/downloadFiles',
    label: 'library.main.DOWNLOADED_FILES',
    isLock: getIsLock(userType, AUTHORIZATION_API.library.downloadFiles),
  },
]

export const LayoutLibrary = ({
  renderTopComponent,
  renderBottomComponent,
}) => {
  const userType = useSelector(selectUserType)
  const AUTHORIZATION_API = useSelector(selectComponentAuthorized)

  return (
    <SideBar
      list={getListSideBar(userType, AUTHORIZATION_API)}
      renderTopComponent={renderTopComponent}
      renderBottomComponent={renderBottomComponent}
      isResponsive={false}
      isShowFooter={false}
    />
  )
}

LayoutLibrary.propTypes = {
  renderTopComponent: PropTypes.func,
  renderBottomComponent: PropTypes.func,
}

LayoutLibrary.defaultProps = {
  renderTopComponent: () => {},
  renderBottomComponent: () => {},
}
